var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71956 8.71922C9.1589 8.27988 9.87121 8.27988 10.3105 8.71922L18.0003 16.409L25.6901 8.71922C26.1295 8.27989 26.8418 8.27988 27.2811 8.71922C27.7204 9.15856 27.7204 9.87088 27.2811 10.3102L19.5913 18L27.2811 25.6898C27.7204 26.1291 27.7204 26.8414 27.2811 27.2808C26.8418 27.7201 26.1295 27.7201 25.6901 27.2808L18.0003 19.591L10.3105 27.2808C9.87121 27.7201 9.1589 27.7201 8.71956 27.2808C8.28022 26.8414 8.28022 26.1291 8.71956 25.6898L16.4093 18L8.71956 10.3102C8.28022 9.87087 8.28022 9.15856 8.71956 8.71922Z",
    fill: "#3F4F68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.55724318c6f23f71338f2266a21b487a.svg";
export { ForwardRef as ReactComponent };